/* global $, ym */
import '../scss/styles.scss'
import {
    bindShowModal,
    configureSentry,
    datepicker,
    fetchModal,
    getCsrfParam,
    getCsrfToken,
    getElementById,
    initTooltip,
    reload,
    selectpicker,
    updateSelectPickerId
} from './utils'
import NchanSubscriber from 'nchan'
import WorksheetDashboard from '../svelte/WorksheetDashboard.svelte'
import moment from 'moment'
import 'moment/locale/ru'
import Schedule from '../svelte/Schedule.svelte'
import WorkTimeWidget from '../svelte/WorkTimeWidget.svelte'
import window from 'inputmask/lib/global/window.js'

moment.locale('ru')

$.datetimepicker.setLocale('ru')

export function subscribeNotification(url) {
    const sub = new NchanSubscriber(url)
    const beep = new Audio('/mixkit-bell-notification-933.mp3')
    beep.load()
    sub.on('message', function(message, metadata) {
        console.log('message', message, metadata)
        const json = JSON.parse(message)
        if (json.type === 'order-count') {
            $('#js-order-count').text(json.payload)
            beep.play().catch(e => console.log(e))
        }
    })

    sub.start()
}

export function userList(params) {
    configureSentry(params.sentry)
    initTooltip()

    const filterBlock = $('.js-filter')
    $('.js-filter-toggle').on('click', () => filterBlock.toggle())

    const tenantRequiredForRoles = params.tenantRequiredForRoles || []
    const options = {
        afterClose() {
            reload()
        },
        beforeShow(modalObject, modalForm) {
            selectpicker(modalForm)
            const tenant = modalForm.find('#js-tenant')
            const role = modalForm.find('#js-role')
            role.on('change', function() {
                const roleId = +$(this).val()
                tenant.prop('disabled',
                    !tenantRequiredForRoles.includes(roleId))
                updateSelectPickerId(tenant, '')
            })
        }
    }
    bindShowModal($('.js-show-modal'), options)
}

export function tenantList(params) {
    configureSentry(params.sentry)
    initTooltip()
    const options = {
        afterClose() {
            reload()
        },
        afterShow(modalObject, modalForm) {
            selectpicker(modalForm)
        }
    }
    bindShowModal($('.js-show-modal'), options)
}

function descriptionGenerator(modalForm) {
    const link = modalForm.find('#js-generate-description')
    const title = link.text()
    link.on('click', async function() {
        const name = modalForm.find('#serviceform-name').val()
        if (!name.trim()) {
            alert('Укажите наименование услуги')
            return
        }
        const formData = new FormData()
        formData.append(getCsrfParam(), getCsrfToken())
        formData.append('title', name)
        link.prop('disabled', true)
        link.text('Генерация описания ...')
        try {
            const result = await fetch('/service/description', {method: 'POST', body: formData})
            if (!result.ok) {
                alert(result.statusText)
                return
            }
            const json = await result.json()
            const resultId = json.model.id
            const timer = setInterval(async function() {
                try {
                    const result = await fetch(`/service/result?id=${resultId}`)
                    if (result.status === 404) {
                        return
                    }
                    clearInterval(timer)
                    if (result.ok) {
                        const json = await result.json()
                        console.log('result', json)
                        modalForm.find('#serviceform-description').val(json.result.description)
                    } else {
                        alert(result.statusText)
                    }
                    link.prop('disabled', false)
                    link.text(title)
                } catch (e) {
                    alert(e)
                    clearInterval(timer)
                    link.prop('disabled', false)
                    link.text(title)
                }
            }, 3000)
        } catch (e) {
            alert(e)
        }
    })
}

export function serviceList(params) {
    configureSentry(params.sentry)
    initTooltip()

    const filterBlock = $('.js-filter')
    $('.js-filter-toggle').on('click', () => filterBlock.toggle())

    const options = {
        afterClose() {
            reload()
        },
        afterShow(modalObject, modalForm) {
            selectpicker(modalForm)
            descriptionGenerator(modalForm)
        }
    }
    bindShowModal($('.js-show-modal'), options)
}

export function worksheetList(params) {
    configureSentry(params.sentry)
    initTooltip()

    const filterBlock = $('.js-filter')
    $('.js-filter-toggle').on('click', () => filterBlock.toggle())

    const options = {
        afterClose() {
            reload()
        },
        afterShow(modalObject, modalForm) {
            selectpicker(modalForm)
        }
    }
    bindShowModal($('.js-show-modal'), options)
}

export function worksheetView(params) {
    configureSentry(params.sentry)
    initTooltip()

    const options = {
        afterClose() {
            reload()
        },
        afterShow(modalObject, modalForm) {
            selectpicker(modalForm)
        }
    }
    bindShowModal($('.js-show-modal'), options)

    $('.js-status').on('click', function() {
        const status = $(this).data('status')
        const formData = new FormData()
        formData.append(getCsrfParam(), getCsrfToken())
        formData.append('status', status)
        fetch(params.statusUrl, {
            method: 'POST',
            body: formData
        }).finally(() => window.location.reload())
    })
}

export function worksheetDashboard(options) {
    configureSentry(options.sentry)

    const datePicker = $('#js-datepicker')
    datepicker(datePicker, {
        onSelectDate() {
            const form = datePicker.parents('form')
            form.submit()
        }
    })

    const opt = {
        afterClose() {
            reload()
        },
        afterShow(modalObject, modalForm) {
            selectpicker(modalForm)
        }
    }
    new WorksheetDashboard({
        target: getElementById('js-dashboard'),
        props: {
            masters: options.masters || [],
            startWork: options.startWork,
            endWork: options.endWork,
            worksheets: options.worksheets || [],
            onClick(masterId, datetime) {
                const date = datetime.format('DD.MM.YYYY')
                const time = datetime.format('HH:mm')
                const params = new URLSearchParams({master_id: masterId, date, time})
                const query = params.toString()
                const url = `/worksheet/create?${query}`
                fetchModal(url, opt)
            }
        }
    })
}

export function scheduleList(opt) {
    configureSentry(opt.sentry)
    const schedulesBlock = getElementById('js-schedules')
    new Schedule({
        target: schedulesBlock,
        props: {
            masters: opt.masters || [],
            dates: opt.dates,
            schedules: opt.schedules || {},
            statuses: opt.statuses || []
        }
    })
}

export function accountProfileUpdate(options) {
    configureSentry(options.sentry)
    const workTimeBlock = getElementById('js-worktime')
    new WorkTimeWidget({
        target: workTimeBlock,
        props: {
            workTime: options.workTime,
            days: options.days,
            formName: options.formName
        }
    })
}

export function registerTenant(options) {
    configureSentry(options.sentry)

    if (typeof ym !== 'undefined' && options.yandexMetrikaCounter) {
        ym(options.yandexMetrikaCounter, 'getClientID', function(clientID) {
            document.getElementById('js-yandex-client-id').value = clientID
        })
    }
}

export function loginUser(options) {
    configureSentry(options.sentry)
}
